import Main from './Main'
import Lista from './components/Justificativa'
import Novo from './components/NovaJustificativa'

export default [
  {
    path: 'pc-justificativa',
    name: 'policiacivil.diarias.justificativa',
    component: Main,
    redirect: { name: 'policiacivil.diarias.justificativa.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.diarias.justificativa.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.diarias.justificativa.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.diarias.justificativa.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/diarias/justificativa/routes.js